import { Reducer, AnyAction } from 'redux';
import { PO_LIST_ACTIONS } from './actions';
import { APPROVE_PO_ACTIONS, PO_DETAILS_ACTIONS, HOLD_REQUEST } from '../details/actions';
import { IPoListState } from './interfaces/po-list-state';
import { DEFAULT_PAGE_SIZE, poBuckets, Bucket } from '@/app-constants';
import { getUserDefinedFilters } from './apis';
import { IPoBucket, IPo } from '../list/interfaces/po-response';
import { PO_CHANGE_REQUEST } from '../details/components/create-po-change-request/actions';

const getOrderByFromBucketTypeId = (bucketTypeId: number) => {
  switch (bucketTypeId) {
    case 3:
      return 'StateTransitionDate';
    case 4:
      return 'StateTransitionDate';
    default:
      return 'ExpectedAcknowledgementDate';
  }
};

const getNextOrderByForPOListRequest = (state: IPoListState, action: AnyAction) => {
  // changing buckets
  if (action.request.bucketTypeId) {
    return getOrderByFromBucketTypeId(action.request.bucketTypeId);
  }

  // used when scrolling
  return getOrderByFromBucketTypeId(state.request.bucketTypeId);
};

export const initialPoListState: IPoListState = {
  request: {
    bucketTypeId: -1,
    orderBy: 'ExpectedAcknowledgementDate',
    orderByDirection: 'Ascending',
    pageNumber: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    filters: getUserDefinedFilters(),
    filterByUnreadMessages: false
  },

  offset: 1,
  total: 0,
  scroll: 0,

  loading: false,
  error: null,

  buckets: [],
  purchaseOrders: [],
  avaliableFilters: [],
  unreadMessageCount: 0,
  flaggedConversationCount: 0,
};

export const poListReducer: Reducer<IPoListState> = (state = initialPoListState, action) => {

  let updatedBuckets = [...state.buckets];
  let purchaseOrders: IPo[];
  let purchaseOrderId: number;

  switch (action.type) {
    case PO_LIST_ACTIONS.REQUEST:
      const nextState = { ...state, loading: true, request: { ...state.request, ...action.request, orderBy: getNextOrderByForPOListRequest(state, action) } };

      if (!action.request.pageNumber) {
        return { ...nextState, purchaseOrders: [], request: { ...nextState.request, pageNumber: 1 } };
      }

      return nextState;

    case PO_LIST_ACTIONS.SUCCESS:
      const { buckets, avaliableFilters, total, offset, flaggedConversationCount, unreadMessageCount } = action.payload;
      ({ purchaseOrders } = action.payload);
      return { ...state, buckets, avaliableFilters, total, offset, flaggedConversationCount, unreadMessageCount, purchaseOrders: [...state.purchaseOrders, ...purchaseOrders], loading: false };

    case PO_LIST_ACTIONS.FAILURE:
      return { ...state, error: action.error, loading: false };

    case PO_LIST_ACTIONS.FILTER:
      return { ...state, purchaseOrders: state.purchaseOrders.filter(po => po.purchaseOrderId !== +action.poId) };

    case PO_LIST_ACTIONS.SCROLL_POSITION:
      return { ...state, scroll: action.scroll };

    case APPROVE_PO_ACTIONS.SUCCESS:
      updatedBuckets = updateBucketCount(updatedBuckets, action.response.bucketType, -1);
      updatedBuckets = incrementBucketCountAfterMove(updatedBuckets, state.purchaseOrders, action.response.poId, poBuckets.confirmed);
      return { ...state, buckets: updatedBuckets };

    case PO_CHANGE_REQUEST.SUCCESS:
      updatedBuckets = updateBucketCount(updatedBuckets, action.payload.changeFrom, -1);
      updatedBuckets = incrementBucketCountAfterMove(updatedBuckets, state.purchaseOrders, action.payload.purchaseOrderId, poBuckets['buyer-review']);
      return { ...state, buckets: updatedBuckets };

    case HOLD_REQUEST.CREATE_SUCCESS:
      updatedBuckets = incrementBucketCountAfterMove(updatedBuckets, state.purchaseOrders, action.payload.purchaseOrderId, poBuckets['on-hold']);
      return { ...state, buckets: updatedBuckets };

    case PO_DETAILS_ACTIONS.MARK_PO_AS_READ:
      return { ...state, purchaseOrders: markPoAsRead(state.purchaseOrders, action.purchaseOrderId) };

    default:
      return state;
  }
};

export const markPoAsRead = (items: IPo[], purchaseOrderId: number) => {
  return items.map((po) => {
    if (po.purchaseOrderId === purchaseOrderId) {
      return {
        ...po,
        hasUnreadMessages: false
      };
    }
    return po;
  });
};

export const incrementBucketCountAfterMove = (buckets: IPoBucket[], purchaseOrders: IPo[], purchaseOrderId: number, bucket: Bucket): IPoBucket[] => {
  let updatedBuckets: IPoBucket[] = buckets;
  const purchaseOrderToMove = purchaseOrders.find(po => po.purchaseOrderId === purchaseOrderId);

  if (purchaseOrderToMove) {
    const existsInBucket = purchaseOrderToMove.orderVerificationBucketTypeIds.find(id => id === bucket.bucketTypeId);
    if (!existsInBucket) {
      // Increment the new bucket count
      updatedBuckets = updateBucketCount(updatedBuckets, bucket.state);
    }
  }

  return updatedBuckets;
};

export const updateBucketCount = (buckets: IPoBucket[], bucketType: string, incrementBy: number = 1) => {
  return buckets.map((bucket) => {
    if (bucket.displayName === bucketType) {
      return {
        ...bucket,
        count: bucket.count + incrementBy
      };
    }
    return bucket;
  });
};
